import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { popupSteps } from "../../../store/common/constants";
import { getCurrentStepWithAnalytics } from "./store/selectors/tariffDetails";
import { AddressAlreadyInUse } from "./components/Steps/AddressAlreadyInUse";
import { getIsOpenPopupFlag } from "./store/selectors/orderTariffCommon";
// components
import { OrderTariffControl } from "./components/OrderTariffControl";
import { AddressRequestForm } from "./components/Steps/AddressRequestForm";
import { AlternativeTariff } from "./components/Steps/AlternativeTariff";
import { Fail } from "./components/Steps/Fail";
import { ShortSuccess } from "./components/Steps/ShortSuccess";
import { AddressNotAvailableModal } from "./components/Steps/AddressNotAvailableModal";
var OrderTariffThreeFieldsPopup = function OrderTariffThreeFieldsPopup(_ref) {
  var currentForm = _ref.currentForm;
  return /*#__PURE__*/React.createElement(OrderTariffControl, {
    isOpen: true,
    "data-t-id": "OrderTariffFormPopup-OrderTariffFormOldPopup"
  }, currentForm === popupSteps.addressRequestForm && /*#__PURE__*/React.createElement(AddressRequestForm, null), currentForm === popupSteps.alternativeTariff && /*#__PURE__*/React.createElement(AlternativeTariff, null), currentForm === popupSteps.shortSuccess && /*#__PURE__*/React.createElement(ShortSuccess, null), currentForm === popupSteps.fail && /*#__PURE__*/React.createElement(Fail, null), currentForm === popupSteps.alreadyInUse && /*#__PURE__*/React.createElement(AddressAlreadyInUse, null), currentForm === popupSteps.addressNotAvailableModal && /*#__PURE__*/React.createElement(AddressNotAvailableModal, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentForm: getCurrentStepWithAnalytics(state),
    shouldRender: getIsOpenPopupFlag(state)
  };
};
var connector = connect(mapStateToProps);
var OrderTariffPopupWithStore = compose(connector, withRenderFlag)(OrderTariffThreeFieldsPopup);
export { OrderTariffPopupWithStore as OrderTariffThreeFieldsPopup };